export const defaultSettings = {
    fileAccept: '*',
    fileLimit: 1,
    iconDelete: 'delete',
    iconEdit: 'edit',
    iconFile: 'insert_drive_file',
    sizeLimit: 1024
};
